import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';

import { AssignmentsService } from '../../../../../services/assignments.service';

@Component({
    selector: 'app-assignment-cancel-substitute-search-modal',
    templateUrl: './assignment-cancel-substitute-search-modal.component.html',
    styleUrl: './assignment-cancel-substitute-search-modal.component.scss'
})
export class AssignmentCancelSubstituteSearchModalComponent implements OnInit {
    @Input() assignmentId!: number;
    @Output() onSuccess = new EventEmitter<boolean>();

    protected isError: boolean = false;
    protected errorMessage: string | null = null;
    protected isLoading: boolean = false;

    constructor(
        private bsModalRef: BsModalRef,
        private assignmentService: AssignmentsService,
        private toastrService: ToastrService,
        private translocoService: TranslocoService
    ) { }

    ngOnInit(): void {
    }

    protected cancelAssignmentSubstitudeSearch(): void {
        this.isLoading = true;

        this.assignmentService.cancelAssignmentSubstitudeSearch(this.assignmentId).subscribe({
            next: (response) => {
                if (response.isSuccess) {
                    this.toastrService.success(this.translocoService.translate('assignments.information.cancelSubstituteSearchSuccess'));
                    this.onSuccess.next(true);
                    this.bsModalRef.hide();
                    return;
                }

                this.isError = true;
                this.errorMessage = response.errorMessage;
                this.isLoading = false;
            },
            error: (err) => {
                this.isError = true;
                this.isLoading = false;
            }
        });
    }
}
